import React from 'react';

export default function PlayIcon({
  width = 32,
  height = 32,
  className,
  style,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <g clipPath="url(#clip0_10068_12102)">
        <path
          d="M15.9995 32C7.1778 32 0 24.8222 0 15.9995C0 7.17685 7.1778 0 15.9995 0C24.8212 0 31.999 7.1778 31.999 15.9995C31.999 24.8212 24.8212 31.999 15.9995 31.999V32ZM15.9995 2.10269C8.33715 2.10269 2.10268 8.33715 2.10268 15.9995C2.10268 23.6619 8.33715 29.8964 15.9995 29.8964C23.6619 29.8964 29.8964 23.6619 29.8964 15.9995C29.8964 8.33715 23.6629 2.10269 15.9995 2.10269Z"
          fill="currentColor"
        />
        <path
          d="M11.9068 24.2386C11.73 24.2386 11.5522 24.1937 11.3926 24.1039C11.0591 23.9165 10.8536 23.5639 10.8555 23.1815L10.9214 9.41087C10.9233 9.03048 11.1307 8.68067 11.4633 8.4962C11.796 8.31174 12.2022 8.3213 12.5262 8.52105L23.6408 15.3863C23.9504 15.5775 24.1397 15.9158 24.1397 16.2809C24.1397 16.646 23.9504 16.9834 23.6408 17.1755L12.4602 24.0809C12.291 24.1851 12.0999 24.2377 11.9078 24.2377L11.9068 24.2386ZM13.0146 11.2966L12.9668 21.2968L21.086 16.2819L13.0146 11.2966Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10068_12102">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
